var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMapIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 10,
    viewBox: "0 0 8 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 5C4.275 5 4.5105 4.902 4.7065 4.706C4.90217 4.51033 5 4.275 5 4C5 3.725 4.90217 3.4895 4.7065 3.2935C4.5105 3.09783 4.275 3 4 3C3.725 3 3.48967 3.09783 3.294 3.2935C3.098 3.4895 3 3.725 3 4C3 4.275 3.098 4.51033 3.294 4.706C3.48967 4.902 3.725 5 4 5ZM4 10C2.65833 8.85833 1.65633 7.79783 0.994 6.8185C0.331333 5.8395 0 4.93333 0 4.1C0 2.85 0.402167 1.85417 1.2065 1.1125C2.0105 0.370833 2.94167 0 4 0C5.05833 0 5.9895 0.370833 6.7935 1.1125C7.59783 1.85417 8 2.85 8 4.1C8 4.93333 7.66883 5.8395 7.0065 6.8185C6.34383 7.79783 5.34167 8.85833 4 10Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapIcon);
export default __webpack_public_path__ + "static/media/mapIcon.23c8edb38f6c039c08d5d42d0453763a.svg";
export { ForwardRef as ReactComponent };